import {
  CreateFormMutation,
  createPaymentFormQRCodeMutation,
  sendPaymentFormNotificationSMSMutation,
  sendPaymentFormNotificationWhatsAppMutation,
  UpdateFormMutation,
} from 'graphql/mutations';
import { getFormsQuery } from 'graphql/query';
import { toast } from 'react-toastify';
import {
  CLEAR_NEW_EXTRA_FIELD,
  CREATE_PAYMENT_FORM,
  CREATE_PAYMENT_FORM_QR_CODE,
  GET_FORMS,
  SEND_PAYMENT_FORM_SMS,
  SEND_PAYMENT_FORM_WHATSAPP,
  UPDATE_PAYMENT_FORM,
} from '../types';

export const getForms = (payload) => {
  return async (dispatch) => {
    const res = await getFormsQuery(payload);
    const data = res.data;
    dispatch({
      type: GET_FORMS,
      data,
    });
    dispatch({ type: CLEAR_NEW_EXTRA_FIELD });
  };
};

export const createPaymentForm = (payload) => async (dispatch) => {
  const res = await CreateFormMutation(payload, dispatch);
  dispatch({ type: CREATE_PAYMENT_FORM, res });
  toast.success(res.createPaymentForm.messages[0]);
};

export const updatePaymentForm = (payload) => async (dispatch) => {
  const res = await UpdateFormMutation(payload, dispatch);
  if (res) {
    dispatch({ type: UPDATE_PAYMENT_FORM, res });
    toast.success(res.updatePaymentForm.messages[0]);
  }
};

export const sendPaymentFormNotificationSMS = (payload) => async (dispatch) => {
  const res = await sendPaymentFormNotificationSMSMutation(payload, dispatch);
  if (res.data) {
    dispatch({ type: SEND_PAYMENT_FORM_SMS, res });
    toast.success(res.data.sendPaymentFormNotificationSMS.messages[0]);
  }
};

export const sendPaymentFormNotificationWhatsApp =
  (payload) => async (dispatch) => {
    const res = await sendPaymentFormNotificationWhatsAppMutation(
      payload,
      dispatch
    );
    if (res.data) {
      dispatch({ type: SEND_PAYMENT_FORM_WHATSAPP, data: res.data });
      toast.success(res.data.sendPaymentFormNotificationWhatsApp.message);
    }
  };

export const createPaymentFormQRCode = (payload) => async (dispatch) => {
  const res = await createPaymentFormQRCodeMutation(payload, dispatch);
  if (res) {
    dispatch({
      type: CREATE_PAYMENT_FORM_QR_CODE,
      data: res.createPaymentFormQRCode,
    });
    toast.success(res.createPaymentFormQRCode.message);
  }
};
